import BasicRouterView from "../../components/BasicRouterView.vue";

const tduRoutes = {
  path: "termosdeuso",
  meta: {
    label: "Termos de Uso",
    icon: "task",
    show: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "termo",
      name: "termo-de-uso",
      meta: {
        label: "Termo",
        icon: "assignment",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "termosDeUso" */ "./views/Termo.vue"),
    },
  ],
};

export default tduRoutes;
